<ng-select
  #dropdown
  class="pencil-searchable-dropdown"
  [class.has-error]="hasError"
  [items]="_items$ | async"
  [ngModel]="$any(selectedItem)?.[bindValue]"
  [searchable]="searchable"
  [searchFn]="customSearchFn ?? undefined"
  [placeholder]="placeholder"
  [bindValue]="bindValue || null"
  [bindLabel]="bindLabel || null"
  [clearable]="false"
  [disabled]="disabled"
  [dropdownPosition]="dropdownPosition"
  [notFoundText]="'No items found' | translate"
  (change)="onChange($event)"
  [appTooltip]="$any(selectedItem)?.[bindLabel]"
  [appTooltipDisabled]="disableTooltip || !bindLabel || !selectedItem || dropdown.isOpen"
  appTooltipPlacement="bottom-center"
>
  <!-- Template for rendering each option in the dropdown list -->
  <ng-template *ngIf="itemTpl" ng-option-tmp let-item="item">
    <ng-container *ngTemplateOutlet="itemTpl; context: { $implicit: item }"></ng-container>
  </ng-template>

  <!--
    Always project ng-label-tmp so the selected value can be cleared while open.
    Closed: custom itemTpl when provided, otherwise the bound label text.
    Open: render nothing so only the search input is visible.
  -->
  <ng-template ng-label-tmp let-item="item" let-label="label">
    <ng-container *ngIf="!dropdown.isOpen">
      <ng-container
        *ngIf="itemTpl; else defaultLabel"
        [ngTemplateOutlet]="itemTpl"
        [ngTemplateOutletContext]="{ $implicit: item }"
      >
      </ng-container>
      <ng-template #defaultLabel>{{ label }}</ng-template>
    </ng-container>
  </ng-template>
</ng-select>
